const removeCookie = (cookieName: string, domain = ".mybenefit.pl"): void => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
};

export default removeCookie;
